import styled from "styled-components";

import { AIAgentChatControls } from "../AIAgentChatControls";

export const StyledAIAgentChatControls = styled(AIAgentChatControls)`
    flex: 1 0;
`;
